import styled from "@emotion/styled";
import { genericStyles } from "../../../../constant";

export const StyledChatInputWrapper = styled.div`
  padding: 12px;
  background: #f9fafb;
  .edit-message-button {
    font-size: 20px;
  }
  .input-box {
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e5e7eb;
    background: #ffffff !important;
    border-radius: 28px;
    padding: 2px 5px;
    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;

    &:focus-within {
      border-color: ${genericStyles.primaryColor};
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
    }
    .attach-button {
      color: ${genericStyles.primaryColor};
      font-size: 18px;
    }

    .emoji-button {
      font-size: 25px;
      padding: 0;
    }

    .emoji-picker {
      position: absolute;
      z-index: 10000;
      bottom: 62px;
    }

    .text-message-input {
      border: none !important;
      box-shadow: none !important;
      resize: none;
      font-size: 16px;
      color: #111827;
      background: transparent;
      &::placeholder {
        color: #9ca3af;
      }
      padding-left: 0px;
    }
  }

  @media (max-width: 767px) {
    .emoji-picker {
      left: 0;
      right: 0;
      padding: 10px;
      .EmojiPickerReact {
        width: 100% !important;
      }
    }
    .input-box {
      gap: 0px;
    }
  }

  .file-messenger-container {
    position: absolute;
    top: 73px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: calc(100% - 73px) !important;
    display: flex;
    flex-direction: column;
    background: #f0f2f5;
    color: #111b21;
  }

  .file-name-display {
    flex: 1;
    text-align: end;
    font-size: 16px;
    font-weight: 400;
    color: #111b21;
    padding: 0 20px;
  }

  .preview-content {
    background: #f0f2f5;
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;

    .preview-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 20px;
    }
    .content-middle-div {
      flex: 1;
      overflow: hidden; /* important */
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
    }
    .message-input-area {
      padding: 8px 30px;
    }
  }

  .preview-image {
    height: 100%;
    object-fit: contain;
    border-radius: 5px;
    width: 100%;
  }

  .preview-file-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .file-icon-large {
    font-size: 80px;
    color: ${genericStyles.primaryColor};
  }

  .file-details {
    text-align: center;
  }

  .file-name-text {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 8px;
    word-break: break-word;
    max-width: 300px;
  }

  .file-size-text {
    font-size: 14px;
    color: #667781;
  }

  .preview-footer {
    padding: 12px 20px;
    background: #ffffff;
    border-top: 1px solid #e9edef;
  }

  .ant-badge-count {
    top: 8px !important;
  }

  .thumbnails-strip {
    display: flex;
    gap: 8px;
    width: calc(100% - 55px);
    overflow-x: auto;
    align-items: center;
    justify-content: center;
  }

  .thumbnail-item {
    position: relative;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s;
  }

  .thumbnail-item:hover {
    border-color: ${genericStyles.primaryColor};
  }

  .thumbnail-item.active {
    border-color: ${genericStyles.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 168, 132, 0.3);
  }

  .thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .thumbnail-file {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9edef;
    font-size: 24px;
    color: ${genericStyles.primaryColor};
  }

  .thumbnail-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .thumbnail-item:hover .thumbnail-remove {
    opacity: 1;
  }

  .add-more-thumbnail {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    border: 2px dashed #d1d7db;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    background: #f0f2f5;
  }

  .add-more-thumbnail:hover {
    border-color: ${genericStyles.primaryColor};
    background: #e9edef;
  }

  .add-icon {
    font-size: 24px;
    color: #667781;
  }

  .add-more-thumbnail:hover .add-icon {
    color: ${genericStyles.primaryColor};
  }

  /* Full screen overlay */
  .drag-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(24, 24, 24, 0.65);
    backdrop-filter: blur(6px);
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;

    animation: fadeIn 0.2s ease-in-out;

    .drag-box {
      border: 2px dashed #ffffff;
      text-align: center;
      color: #ffffff;

      background: rgba(255, 255, 255, 0.05);
      transition: all 0.2s ease;

      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    /* Hover effect while dragging */
    .drag-box:hover {
      border-color: #40a9ff;
      background: rgba(64, 169, 255, 0.1);
    }

    .drag-icon {
      font-size: 40px;
      margin-bottom: 10px;
    }

    .drag-text {
      font-size: 16px;
      opacity: 0.9;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
`;
